<template>
  <div id="ua-container">
    <a-card class="ui-card card-box">
      <div class="info-box">
        <div class="left-box">
          <div class="img-box">
            <img :src="value.url" alt="封面加载失败" />
          </div>
          <div>
            <div class="big-title" v-if="value.name">
              {{ value.name }}
            </div>
            <div class="text-item material-title">
              <div class="block"></div>
              <div>
                {{ value.standardName ? value.standardName : "-" }}
              </div>
            </div>
            <div class="text-item">
              年级：{{ value.gradeName ? value.gradeName : "-" }}
            </div>
            <div class="text-item">
              科目：{{ value.subjectName ? value.subjectName : "-" }}
            </div>
            <div class="flex alignItemsCenter">
              <div class="text-item mb-0">
                创建时间：{{ value.createTime ? value.createTime : "-" }}
              </div>

              <!--
              <a-button type="primary" ghost size="small" class="down-btn" @click="handleDownAnswer" v-if="value.answerUrl">
                下载答案
              </a-button>
              -->
              <a
                v-if="value.answerUrl"
                class="down-btn ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost"
                :href="value | genDownloadUrl('答案')"
              >下载答案</a>
            </div>
          </div>
        </div>
        <div>
          <a-button type="primary" class="orange-btn" @click="toReturn">
            <a-icon type="rollback" />
            返回列表
          </a-button>
        </div>
      </div>
    </a-card>
    <a-spin :spinning="loading">
      <a-card class="ui-card card-box2">
        <div class="pagination-box">
          <a-pagination
            show-quick-jumper
            :total="pageCount"
            :pageSize="1"
            v-model="pageNum"
            :showTotal="(e) => `共：${pageCount ? pageCount : '0'}页`"
            size="default"
            style="margin-bottom: 20px"
            @change="pageChange"
            v-if="value.subject !== 'ENGLISH'"
          />
          <div class="left-title" v-else><a-icon type="customer-service" /> 听力</div>
          <a-button class="btn" type="primary" @click="openListen" v-if="value.subject === 'ENGLISH'">
            <voice v-if="isShowVoice" />
            <div :class="{title: isShowVoice}">
              查看答案
            </div>
          </a-button>
        </div>

        <template v-if="value.subject !== 'ENGLISH'">
          <div v-if="value.answerUrl">
            <div v-if="!isError">
              <div class="mask" v-if="parseInt(loadedRatio * 100) !== 100">
                <span>{{ loadingText }}</span>
                <a-progress
                  style="width: 280px"
                  strokeColor="#28b8ba"
                  :strokeWidth="10"
                  :percent="parseInt(loadedRatio * 100)"
                />
              </div>
            </div>
            <div class="loadError" v-else>答案加载失败，请稍后重试...</div>
            <ui-pdf
              class="pdfMain"
              :class="{ pdfContent: parseInt(loadedRatio * 100) === 100 }"
              :src="value.answerUrl"
              :page="pageNum"
              @progress="loadedRatio = $event"
              @num-pages="pageCount = $event"
              @error="pdfError($event)"
            />
          </div>
          <div v-else class="no-data">
            <a-empty description="暂无数据" />
          </div>
        </template>
        <template v-else>
          <div class="player-box" v-if="audioList && audioList.length > 0">
            <audio-player
              ref="audioPlayer"
              :playlist="audioList"
              @ended="onAudioEnded"
            />
          </div>
          <div class="no-data" v-else>
            <a-empty description="暂无听力" />
          </div>
        </template>
      </a-card>
    </a-spin>

    <template>
      <a-drawer
        title="查看答案"
        placement="right"
        :closable="true"
        width="48vw"
        :visible="listenVisible"
        @close="listenClose"
      >
        <a-spin :spinning="aloading">
          <a-pagination
            show-quick-jumper
            :total="pageCount"
            :pageSize="1"
            v-model="pageNum"
            :showTotal="(e) => `共：${pageCount ? pageCount : '0'}页`"
            size="default"
            style="margin-bottom: 20px"
            @change="pageChange"
          />
          <div v-if="value.answerUrl">
            <div v-if="!isError">
              <div class="mask" v-if="parseInt(loadedRatio * 100) !== 100">
                <span>{{ loadingText }}</span>
                <a-progress
                  style="width: 280px"
                  strokeColor="#28b8ba"
                  :strokeWidth="10"
                  :percent="parseInt(loadedRatio * 100)"
                />
              </div>
            </div>
            <div class="loadError" v-else>答案加载失败，请稍后重试...</div>
            <ui-pdf
              class="pdfMain"
              :class="{ pdfContent: parseInt(loadedRatio * 100) === 100 }"
              :src="value.answerUrl"
              :page="pageNum"
              @progress="loadedRatio = $event"
              @num-pages="pageCount = $event"
              @error="pdfError($event)"
            />
          </div>
          <div v-else class="no-data">
            <a-empty description="暂无数据" />
          </div>
        </a-spin>
      </a-drawer>
    </template>
  </div>
</template>

<script>

import axios from 'axios'
import uiPdf from "vue-pdf"
import voice from '@/components/voice/index.vue'
import audioPlayer from '@/components/player/index.vue'
import { getLessonAduioList } from '@/api/material.js'
import { genDownloadUrl } from "../utils.js"

export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    uiPdf,
    voice,
    audioPlayer
  },
  data() {
    return {
      // 加载进度
      loadedRatio: 0,
      pageNum: 1,
      loadingText: "努力加载中...",
      pageCount: 0,
      loading: false,
      isError: false,
      aloading: false,
      listenVisible: false,
      audioList: [],
      isShowVoice: false,
    }
  },
  mounted() {
    if (this.value) {
      this.getLessonAduioList(this.value.id)
    }
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.toBack, false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.toBack, false)
  },
  filters: {
    genDownloadUrl,
  },
  methods: {
    // 返回
    toReturn() {
      this.$emit("change")
      this.isError = false
    },
    // 监听浏览器返回或手机物理按键返回
    toBack () {
      this.toReturn()
    },
    pdfError(err) {
      this.isError = true
    },
    handleDownAnswer () {
      this.downloadPdf(this.value.answerUrl, this.value.name)
    },
    async downloadPdf(pdfUrl, pdfName) {
      try {
        const response = await axios.get(pdfUrl, {
          responseType: 'blob' // 关键：接收二进制数据
        })

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = pdfName + '.pdf'
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请稍后重试')
      }
    },
    pageChange() {
      if (this.value.subject !== 'ENGLISH') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 300)
      } else {
        this.aloading = true
        setTimeout(() => {
          this.aloading = false
        }, 300)
      }
    },
    openListen () {
      this.aloading = true
      this.listenVisible = true
      setTimeout(() => {
        this.aloading = false
      }, 300)
    },
    listenClose () {
      this.listenVisible = false
    },
    getLessonAduioList (materialId) {
      this.loading = true
      this.audioList = []
      getLessonAduioList(materialId).then(res => {
        if (res.code === 0) {
          const audioList = res.data
          this.audioList = this.formatMaterialData(audioList)
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('服务器异常，听力加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    formatMaterialData (data) {
      let list = []
      if (data && data.length > 0) {
        data.forEach(item => {
          list.push({
            id: item.id,
            title: item.name,
            src: item.audioUrl,
            cover: this.value.url
          })
        })
      }
      return list
    },
    // 播放
    handPlay () {
      this.isShowVoice = true
    },
    // 暂停
    handPause () {
      this.isShowVoice = false
    },
    onAudioEnded () {
      this.isShowVoice = false
    },
  }
};
</script>

<style lang="less" scoped>
#ua-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: auto;
  background-color: #fff;
}
.info-box {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
// 修改新增等操作按钮默认颜色
.orange-btn{
  background-color: #FA7837;
  border-color: #FA7837;
  &:hover{
    background-color: #fa905b;
    border-color: #fa905b;
  }
}
.card-box{
  border: none;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid rgb(235, 233, 233);
}
.card-box2 {
  border: none;
  position: relative;
  min-height: 57vh;
  border-left: none;
  border-right: none;
  border-bottom: none;
}
.mask {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 99;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.left-box {
  display: flex;
  align-items: center;
  max-width: 90%;
  .img-box {
    width: 100px;
    height: 130px;
    margin-right: 30px;
    white-space: nowrap;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .big-title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    margin-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .material-title{
    color: #FA6400 !important;
    font-weight: 600 !important;
    display: flex;
    align-items: center;
    .block{
      width: 5px;
      height: 5px;
      background-color: #FA6400;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
  .text-item {
    font-size: 13px;
    color: #666666;
    font-weight: 500;
    margin-bottom: 7px;
    &:nth-last-child(1){
      margin-bottom: 0;
    }
  }
}
.pdfMain {
  max-width: 600px;
  margin: 0 auto;
}
.pdfContent {
  box-shadow: 0 0 5px 1px #999;
}
.card-box2 .no-data {
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loadError {
  text-align: center;
  margin-top: 12%;
}
.pagination-box{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .btn{
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #fff;
    border-color: #28b8ba;
    color: #28b8ba;
    display: flex;
    align-items: center;
    .title{
      margin-left: 10px;
    }
  }
}
/deep/ .player-box{
  .speed-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .aplayer-list {
  }
  .aplayer-list ol{
    overflow-y: visible !important;
  }
  .aplayer-list ol li{
    height: auto !important;
  }
  .aplayer-list-title {
    letter-spacing: 1px;
  }
}
.left-title{
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 30px;
  font-weight: 600;
}
.no-data{
  height: 70vh;
}
.down-btn{
  text-align: center;
  background-color: #fff;
  border-color: #28b8ba;
  color: #28b8ba;
  margin-left: 20px;
  &:hover{
    border-color: #28b8ba;
    color: #28b8ba;
  }
}
.mb-0{
  margin-bottom: 0 !important;
}
</style>
